export { default } from './SalesProcessToolTip';
